import axios from '@/jslib/axios'

export const getPromotionProductList = params => {
  return axios({
    method: 'get',
    url: '/admin/promotion/product/list',
    params
  })
}
export const getPromotionDetail = id => {
  return axios({
    method: 'get',
    url: `/admin/promotion/product/detail/${id}`,
  })
}
export const createPromotionProduct = data => {
  return axios({
    method: 'post',
    url: '/admin/promotion/product',
    data
  })
}
export const updatePromotionProduct = data => {
  return axios({
    method: 'patch',
    url: '/admin/promotion/product',
    data
  })
}
export const deletePromotionProduct = data => {
  return axios({
    method: 'delete',
    url: '/admin/promotion/product/delete',
    data
  })
}
export const sortPromotionProduct = data => {
  return axios({
    method: 'put',
    url: '/admin/promotion/product/sort',
    data
  })
}
